import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { FileQuestion, Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-6"
      data-testid="not-found-page"
    >
      <Card className="max-w-lg w-full border-slate-200 shadow-sm">
        <CardContent className="p-8 text-center space-y-6">
          <div className="mx-auto w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center">
            <FileQuestion className="w-8 h-8 text-amber-600" />
          </div>

          <div className="space-y-2">
            <p className="text-6xl font-bold text-slate-900 tracking-tight">404</p>
            <h1 className="text-xl font-semibold text-slate-800">Pagina non trovata</h1>
            <p className="text-sm text-slate-500">
              La pagina che stai cercando non esiste o è stata spostata.
            </p>
            {location.pathname && (
              <p
                className="text-xs font-mono text-slate-400 bg-slate-50 border border-slate-100 rounded px-2 py-1 inline-block mt-2 break-all"
                data-testid="not-found-path"
              >
                {location.pathname}
              </p>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-2 justify-center">
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              data-testid="not-found-back-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Torna indietro
            </Button>
            <Button
              onClick={() => navigate('/dashboard')}
              data-testid="not-found-home-btn"
            >
              <Home className="w-4 h-4 mr-2" />
              Vai alla Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
